// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"a3137577","163":"cea26fc0","321":"3bc7b2c1","420":"dfd210a9","498":"97c6b126","528":"2c0bc658","677":"59648ecb","769":"1b06a6e0","972":"b22a91f6"}[chunkId] + ".chunk.js";
};